import classNames from './MyProfile.module.scss';
import { useAppSelector } from '@/store';
import { authSelector } from '@/store/reducers/auth';
import UseMyProfile from '@/hooks/UseMyProfile';

import Navbar from '../Navbar/Navbar';
import UserInfo from '../UserInfo/UserInfo';
import ProfileCard from './ProfileCard/ProfileCard';
import UseCurrentRoute from '@/hooks/UseCurrentRoute';
import { ROUTE_NAMES } from '@/router';
import MyProgress from './MyProgress/MyProgress';
import AppLoaderCircle from '../AppLoaderCircle';
import Badge from '@/components/UserInfo/Badge/Badge';
import blueStar from '@/assets/svg/star.svg';
import coin from '@/assets/svg/coin.svg';

const MyProfileMobile = () => {
  const { user } = useAppSelector(authSelector);
  const currentRoute = UseCurrentRoute();

  const handleProgressCardClick = () => {
    return;
  };

  const { isLoading, unitsProgress, isLevelComplete } = UseMyProfile();

  return (
    <div className={classNames.myProfileMobile}>
      <Navbar showArrowIcon={currentRoute === ROUTE_NAMES.PROFILE} className={classNames.navbar}>
        <div className={classNames.header}>
          {user && (
            <>
              <UserInfo
                fullname={`${user.metadata.firstName} ${user.metadata.lastName}`}
                firstName={user.metadata.firstName}
                lastName={user.metadata.lastName}
                profileImage={user.metadata.userSettings.avatar?.avatarName}
                backgroundColor={user.metadata.userSettings.avatar?.avatarColor}
                notificationsAmount={3}
                level={user.progress?.userLevel}
                grade={user?.metadata.organizationDetails.grade.toString()}
              />
              <div className={classNames.badges}>
                <Badge type='stars' image={blueStar} amount={user?.progress?.achievedStars} />
                <Badge type='coins' image={coin} amount={user.progress?.coins} />
              </div>
            </>
          )}
        </div>
      </Navbar>
      {isLoading && (
        <div className={classNames.myProfileMobileLoading}>
          <AppLoaderCircle />
        </div>
      )}
      {!isLoading && (
        <div className={classNames.myProfileMobileContent}>
          <ProfileCard
            className={classNames.profileCard}
            classroom={user?.metadata.organizationDetails?.groupName}
            level={user?.progress?.userLevel}
            grade={user?.metadata.organizationDetails.grade}
            school={user?.metadata.organizationDetails.organizationName}
            country={user?.metadata.organizationDetails.country}
          />
          <MyProgress
            className={classNames.myProgress}
            unitsProgress={unitsProgress}
            onProgressCardClick={handleProgressCardClick}
            showCompletedNotice={isLevelComplete}
          />
        </div>
      )}
    </div>
  );
};

export default MyProfileMobile;
